<!-- 编辑Office-PPT文件 -->
<template>
    <div class="edit-container">
        <div class="l-edit-container">
            <iframe class="web-container" :src="this.editForm.viewUrl"></iframe>
        </div>
        <div class="r-edit-container">
            <div class="r-top-container">
                <div class="top-title">超链接资源</div>

                <div class="mode-title" v-if="role==1||role==2||isRwmy==1" @click="rwmyResource">人文美育</div>

                <div style="width: 100%" v-if="!(role==1||role==2||isRwmy==1)">
                    <dataEmpty title="暂无资源" />
                </div>
            </div>
            <div class="r-bottom-container">
                <div class="sub-btn" @click="saveEdit">保&nbsp;&nbsp;存</div>
            </div>
        </div>
    </div>

    <el-dialog class="ve-dialog"  title="人文美育资源" v-model="isRwmyVideoShow" width="880px" top="2vh" >
        <div class="parent-container">
            <!--目录-->
            <div class="l-container">
                <div class="l-second-container">
                    <div class="second-box1">
                        <svg t="1755139711785" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17744" width="16" height="16"><path d="M0 1024V128h256V0h128v128h256V0h128v128h256v896H0zM924.384 227.616H99.616v696.768h824.768V227.616z m-578.048 185.6l125.12 349.152h-83.2l-23.104-71.84H234.496l-23.136 71.84H128l125.12-349.152h93.216z m-1.952 213.696l-44.64-138.336-44.608 138.336h89.248z m235.648 66.048h106.496v69.408H512V413.12h68.032v279.744z m192 0h106.528v69.408H704V413.12h68.032v279.744z" fill="#ff7f2e" p-id="17745"></path></svg>
                    </div>
                    <div class="second-box2 cursor" @click="handleAllVideo">所有视频</div>
                    <div class="second-box3 cursor" @click="handleAllVideo">{{treeData.videoNum}}</div>
                </div>
                <el-scrollbar class="l-tree-container">
                    <el-tree
                      :data="categoryList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ node, data }">
                            <div class="custom-tree-node" :title="charConversion(data.categoryName)">
                                <div>
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </div>
                                <div>
                                    <el-button type="primary" style="color: #606266;margin-left: 5px;" link>{{data.videoNum}}</el-button>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <!--视频列表-->
            <div class="r-container">
                <div class="form-box">
                    <el-form ref="queryForm"
                             :model="queryParams"
                             :inline="true"
                             label-width="90px">
                        <el-row >
                            <el-col :span="12">

                            </el-col>
                            <el-col :span="12">
                                <el-form-item class="pull-right">
                                    <el-input v-model="queryParams.title" placeholder="请输入视频名称" class="input-with-select">
                                        <template #append>
                                            <el-button type="primary" @click="handleQuery" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="bre9e mt5">
                    <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                              height="calc(100vh - 195px)"
                              :data="dataList"
                              highlight-current-row>
                        <el-table-column type="index" align="center" label="序号" width="60" />
                        <el-table-column width="80px" align="center" label="封面" prop="coverUrl">
                            <template #default="scope">
                                <img alt="" :src="scope.row.coverUrl" width="40" height="22" class="cursor" style="margin-top: 5px"/>
                            </template>
                        </el-table-column>
                        <el-table-column width="220px" align="center" label="视频名称" prop="title">
                            <template #default="scope">
                                <div :title="scope.row.title" @click="viewVideo(scope.row)" style="color: #409efe;" class="text-one cursor">
                                    {{ scope.row.title }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="时长" prop="duration">
                            <template #default="scope">
                                <div>{{ formatSecondDate(scope.row.duration)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column width="140px" align="center" label="上传时间" prop="creationTime">
                            <template #default="scope">
                                <div>{{ moment(scope.row.creationTime).format("YYYY-MM-DD hh:mm")}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="标签" prop="tags">
                        </el-table-column>
                        <el-table-column fixed="right" width="100" label="操作" align="center">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="linkClipboard(scope.row.videoId)">复制链接</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="zdyfy">
                    <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]"  :total="total"
                                :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="queryHumanityVideo" />
                </div>
            </div>
        </div>
    </el-dialog>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>
</template>
<script>
import {formatSecondDate, timestampToTime } from "@/utils/date";
import { beginFileEdit,saveFileEdit} from "@/api/admin/office";
import {treeCategory,pageHumanityVideo} from "@/api/admin/humanity";
import {charConversion} from "@/utils/str"
import {ElLoading} from "element-plus";
import dataEmpty from "@/components/dataEmpty.vue";
import moment from "moment"
import {serviceUrl,serviceWebUrl} from "@/utils/global";
export default {
    name: "homeEditOffice",
    components: {dataEmpty},
    data() {
        return {
            serviceUrl,
            serviceWebUrl,
            formatSecondDate,
            moment,
            charConversion,
            isRwmyVideoShow:false,
            isViewVideoShow:false,
            fileId:'',
            fileForm:{
                fileId:'',
                originType:1,
            },
            editForm:{
                fileId:"",
                viewUrl:"",
                viewId:"",
            },
            timestampToTime,
            role:this.$storage.get("role"),
            isRwmy:JSON.parse(this.$storage.get("userInfo")).isRwmy,
            tagList: [
                { name: '全部', value: '' },
                { name: '已设置', value: 1 },
                { name: '未设置', value: 0 },
            ],
            courseList: [
                { name: '全部', value: '' },
                { name: '已关联', value: 1 },
                { name: '未关联', value: 0 },
            ],

            treeList:{},
            treeData:{},
            categoryList:[],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            total: 0,
            dataList: [],
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                title: '',
                categoryId: '',
                isTag: '',
                isCourse: '',
            },
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
        };
    },
    created() {},
    mounted() {
        this.fileId = this.$route.query.fid;
        this.fileForm.fileId = this.$route.query.fid;
        this.fileEdit();
        this.queryTreeCategory();
        this.queryHumanityVideo();
    },
    computed: {},
    methods: {

        linkClipboard(vid) {
            const link = serviceWebUrl+'/jzedu/officeLink?vid='+vid
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(link).then(() => {
                    this.$message.success("复制成功");
                }).catch(err => {
                    this.fallbackCopy(link); // 降级方案
                });
            } else {
                this.fallbackCopy(link); // 直接使用降级方案
            }
        },
        fallbackCopy(text) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                const success = document.execCommand('copy');
                this.$message.success("复制成功");
            } catch (err) {
                this.$message.success("复制失败");
            } finally {
                document.body.removeChild(textarea);
            }
        },
        rwmyResource(){
            this.isRwmyVideoShow=true;
        },
        fileEdit(){
            beginFileEdit(this.fileForm).then(res => {
                if (res.data.code===1){
                    this.editForm = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        saveEdit(){
            const loading = ElLoading.service({ fullscreen: true })
            saveFileEdit({ fileId: this.fileId }).then(res => {
                if (res.data.code===1){
                    this.$message.success("保存成功");
                    loading.close()
                }else {
                    this.$message.error(res.data.msg);
                    loading.close()
                }
            })
        },
        queryTreeCategory(){
            treeCategory().then(res => {
                if (res.data.code===1){
                    if (res.data.data){
                        this.treeList= res.data.data;
                        this.treeData = this.treeList[0];
                        this.categoryList = this.treeData.children;
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleAllVideo(){
            this.queryParams.categoryId='';
            this.queryHumanityVideo();
        },
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryParams.title = '';
            this.queryParams.isTag = '';
            this.queryParams.isCourse = '';
            this.queryHumanityVideo();
        },
        handleQuery(){
            this.queryHumanityVideo();
        },
        queryHumanityVideo(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageHumanityVideo(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            })
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })

        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        onCopy() {
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        onError() {
            this.$message.error('复制失败');
        },
    },

}
</script>
<style scoped>
.edit-container{
    width: 100%;
    height: 100vh;
    display: flex;
    font-family: sans-serif;
    overflow: hidden;
}
.l-edit-container{
    width: calc(100% - 120px);
    height: 100vh;
}
.web-container{
    width: 100%;
    height: 100%;
}
.r-edit-container{
    width: 120px;
    height: 100vh;
    background-color: #f9f9f9;
    border-left: 1px solid #c1c1c1;

}
.r-top-container{
    width: 100%;
    height: calc(100% - 40px);
}
.top-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    font-family: sans-serif;
    background-color: #ff7f2e;
    text-align: center;
}
.mode-title{
    width: 100px;
    height: 36px;
    margin: auto;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    color: #ff7f2e;
    line-height: 36px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    font-family: sans-serif;
    margin-top: 10px;
    border: 1px solid #ff7f2e;
}
.mode-title:hover{
    background-color: #ff7f2e!important;
    color: #fff!important;
}
.r-bottom-container{
    width: 100%;
    height: 40px;

}
.sub-btn{
    width: 100px;
    height: 36px;
    margin: auto;
    background-color: #ff7f2e;
    border-radius: 10px;
    text-align: center;
    color: #fff;
    line-height: 36px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    font-family: sans-serif;
}




.parent-container{
    height: calc(100vh - 85px);
    width: 100%;
    overflow-x: hidden!important;
    box-sizing: border-box;
    display: flex;
}
.l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
}
.l-top-container{
    width: 100%;
    height: 50px;
    padding: 10px 0 10px 0;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1.5px solid #f1f1f1;
    display: flex;
}
.l-box{
    width: 50%;
    height: 100%;
    line-height: 28px;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    padding-left: 10px;
    color: #242424;
}
.r-box{
    width: 50%;
    height: 100%;
    font-size: 15px;
    font-family: sans-serif;
    text-align: right;
    padding-right: 10px;
    color: #676767;
    display: flex;
    justify-content: flex-end;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 10px;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 85px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.tree-item-child1{
    width: 20px!important;
}
.tree-item-child2{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.tree-item-child3{
    width: 40px!important;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}
.r-container{
    width: calc(100% - 270px);
    height: 100%;
    margin-left: 10px;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 0 0 0;
    box-sizing: border-box;
}
.form-box{
}
.ar-form /deep/ .el-form-item{
    margin-bottom: 10px!important;
}
.ar-form /deep/ .el-form-item__label{
    color:#121212!important;
    font-weight:bold;
    font-size:15px
}

.ve-dialog /deep/ .el-dialog__header{
    height: 30px!important;
    padding-bottom: 0!important;
}

.v-title{
    font-family: sans-serif;
    font-size: 16px;
    color: #121212;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-weight: 400;
}
.tag-input{
    width: 200px;
    height: 24px;
}
.create-tag-container{
    width: 100%;
    height: 30px;
    display: flex;

}
.zero-tag-box{
    height: auto;
    padding: 0 10px 0 10px;
}
.zero-tag-box{
    font-family: sans-serif;
    font-size: 14px;
    color: #666666;
    width: 100%;
    padding-bottom: 5px;
    text-align: left;
}
.v-tag{
    margin-right: 10px;
    margin-bottom: 5px;
    background-color: #a4adb3;
    color: #fff;
}
.book-container{
    width: 100%;
    height: auto;
}
.video-tag{
    margin-right: 10px;
    margin-bottom: 10px;
    //max-width: 200px;
    //overflow: hidden;
    //text-overflow: ellipsis;
    //white-space: nowrap;
}
</style>